import {resolveBackground} from '#core/utils/color-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';
import {icon} from '#core/utils/style-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {generatePivotButton} from '#core/application/modules/tiles/pivot/index.js';
import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';

export function applicationHeaderFactory(PALETTE) {
    const crossSellMenuLinks = buildIntentsFromConfig(ApplicationConfig.config.crossSellMenuLinks);
    const HEADER_SHADOW = {
        ...(PALETTE.APPLICATION_HEADER_MOBILE_SHOW_SHADOW
            ? {_mobile_boxShadow: PALETTE.APPLICATION_HEADER_SHADOW}
            : {}),
        ...(PALETTE.APPLICATION_HEADER_DESKTOP_SHOW_SHADOW
            ? {_desktop_boxShadow: PALETTE.APPLICATION_HEADER_SHADOW}
            : {}),
    };

    return {
        ApplicationHeader: {
            headerContentContainer: {
                ...resolveBackground(PALETTE.APPLICATION_HEADER_BG),
                // ...HEADER_SHADOW, //TODO: Header shadow doesn't allowed in mojito :(
            },
            headerContainer: {
                zIndex: 10,
            },
            normalLayout: {
                applicationMenu: {
                    style: {
                        sideColumns: {
                            flexBasis: '30%',
                        },
                    },
                },
            },
        },
        ApplicationHeaderSkeleton: {
            container: {
                style: {
                    height: '104px',
                    ...resolveBackground(PALETTE.APPLICATION_HEADER_BG),
                    ...HEADER_SHADOW,
                },
            },
            buttonSkeleton: generateSkeletonPart(PALETTE.APPLICATION_HEADER_BUTTONS_SKELETON),
        },
        CrossSellMenu: {
            // Please do not put here styles
            // Instead use ones in ApplicationMenu and AZOverview
            // Because they are completely different for desktop and mobile
        },
        ApplicationMenu: {
            style: {
                innerContainer: {
                    flexBasis: 64,
                    _mobile_flexBasis: 48,
                },
            },
            logo: {
                src: 'generic/logo.svg',
                style: {
                    flexGrow: 0,
                },
            },
            multiRowLayout: {
                crossSellMenu: buildDesktopCrossSellConfig(PALETTE, crossSellMenuLinks, false),
            },
            singleRowLayout: {
                crossSellMenu: buildDesktopCrossSellConfig(PALETTE, crossSellMenuLinks, true),
            },
            searchIcon: icon(PALETTE.APPLICATION_HEADER_SEARCH_BUTTON.TERTIARY_BUTTON_ICON_COLOR),
            systemInitialisation: {
                title: {
                    style: {
                        ...PALETTE.APPLICATION_HEADER_SYSTEM_INITIALIZATION_TITLE_TEXT,
                    },
                },
                timeRemaining: {
                    style: {
                        ...PALETTE.APPLICATION_HEADER_SYSTEM_INITIALIZATION_TIME_REMAINING_TEXT,
                    },
                },
            },
        },
        UserAuthenticationInfo: {
            loginButton: {
                button: merge(generateSecondaryButton(PALETTE.APPLICATION_HEADER_LOGIN_BUTTON), {
                    style: {
                        base: {
                            padding: '0 8px',
                        },
                    },
                }),
            },
            signupButton: {
                button: merge(generatePrimaryButton(PALETTE.APPLICATION_HEADER_SIGNUP_BUTTON), {
                    style: {
                        base: {
                            padding: '0 8px',
                        },
                    },
                }),
            },
        },
        AccountMenu: {
            popupToggleButton: {
                style: {
                    base: {
                        flexGrow: 0,
                    },
                },
            },
            popupToggleButtonInfoPane: {
                itemSpacing: 2,
                style: {
                    padding: '0 8px 0 0',
                },
            },
            popupToggleButtonIcon: {
                src: 'account',
                style: {
                    fill: PALETTE.APPLICATION_HEADER_USER_INFO_ICON_COLOR,
                    minHeight: 24,
                    minWidth: 24,
                    alignSelf: 'center',
                },
            },
            logout: {
                hide: true,
            },
            usernameText: {
                style: {
                    ...PALETTE.APPLICATION_HEADER_USER_INFO_NAME_TEXT,
                },
            },
            balanceValueText: {
                style: {
                    ...PALETTE.APPLICATION_HEADER_USER_INFO_BALANCE_TEXT,
                },
            },
        },
    };
}

function buildDesktopCrossSellConfig(PALETTE, LINKS, IS_SINGLE_ROW = false) {
    const BASE_STYLES = IS_SINGLE_ROW
        ? {
              flex: '0 1 auto',
              padding: 0,
          }
        : {
              flex: '0 1 auto',
              padding: '0 26px',
          };

    return {
        links: LINKS,
        linkButtons: {
            container: {
                itemSpacing: 32,
                style: {
                    padding: 0,
                },
            },
            selectableButton: merge(generatePivotButton(PALETTE.APPLICATION_HEADER_CROSS_APP_SELECTOR), {
                selected: {
                    style: {
                        base: BASE_STYLES,
                    },
                },
                unselected: {
                    style: {
                        base: BASE_STYLES,
                    },
                },
                indicator: {
                    style: {
                        base: {
                            left: 0,
                            right: 0,
                        },
                    },
                },
            }),
            disableSelectedButton: false,
        },
        linkLabel: {
            style: {
                padding: 0,
            },
        },
    };
}
